@if ((getVisiblePages()?.length || 0) > 1) {
  <div class="pagination">
    <!-- paginate to left button -->
    <button class="pagination__nav-btn" (click)="navigateToPrevPage()">
      <i class="iconsax" icon-name="chevron-left"></i>
    </button>

    <!-- pagination dots -->
    <ul class="pagination__pages-container">
      @if (getVisiblePages()[0] > 1) {
        <li class="page-dots"><span>...</span></li>
      }

      <!-- pagination numbers -->
      @for (page of getVisiblePages(); track page) {
        @if (page !== pages) {
          <li
            class="page-numbers"
            [ngClass]="{ 'page-numbers--active': currentPage === page }"
            (click)="setCurrentPage(page)">
            <span>{{ page }}</span>
          </li>
        }
      }

      <!-- pagination dots -->
      @if (getVisiblePages().slice(-1)[0] < pages) {
        <li class="page-dots"><span>...</span></li>
      }

      <!-- last page -->
      <li
        class="page-numbers"
        [ngClass]="{ 'page-numbers--active': currentPage === pages }"
        (click)="setCurrentPage(pages)">
        <span>{{ pages }}</span>
      </li>
    </ul>

    <!-- paginate to right button -->
    <button class="pagination__nav-btn" (click)="navigateToNextPage()">
      <i class="iconsax" icon-name="chevron-right"></i>
    </button>
  </div>
}
